export default {"src":"https://cloudflare.edhrec.com/_next/static/media/mana2b.be9a1cef.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};